import React from "react";

export const LegalPage = ({ data, testid }) => (
  <main className="pt-40 pb-20" data-testid={testid}>
    <div className="max-w-3xl mx-auto px-6">
      <h1 className="font-display font-extrabold text-4xl sm:text-5xl text-white tracking-tighter">{data.title}</h1>
      <p className="text-slate-500 text-sm mt-3 font-mono">{data.updated}</p>
      <p className="text-slate-300 mt-8 leading-relaxed">{data.intro}</p>
      {data.sections.map((s, i) => (
        <section key={i} className="mt-10">
          <h2 className="font-display font-bold text-white text-xl">{s.h}</h2>
          {s.body.map((p, ii) => (
            <p key={ii} className="text-slate-400 mt-3 leading-relaxed">{p}</p>
          ))}
        </section>
      ))}
    </div>
  </main>
);
